import React from 'react';
import { FormRefsContextProps } from './form-refs-context-props';

export const FormRefsContext = React.createContext<FormRefsContextProps>(Object.assign({}));
